import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  salesReturnEditAction,
  salesReturnReceiptCreateAction,
} from "../../../redux/actions/sales-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import SalesPurchaseNavbar from "../sales-purchase-navbar";
import SalesPurchaseFooter from "../sales-purchase-footer";
import SalesItemsSection from "../sales-items-sec";
import SalesRCNBatchesPanel from "../sales-retun-cn-batches-panel";
const CreateEditViewSalesRet = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  type = "",
  page = "",
  disabled = false,
  data = {},
  standAlone = false,
  payto,
  shipto,
  pageType,
  clickedplus,
  isNotViewOnly=true,
  transfer=false
}) => {
  const [heading, setHeading] = useState([]);
  // ✅ helpers (keep in a utils file)
const num0 = (v) => {
  if (v === null || v === undefined) return 0;

  if (typeof v === "number") return Number.isFinite(v) ? v : 0;

  if (typeof v === "string") {
    const s = v.trim();
    if (!s) return 0;

    // handles: "1,234.50", "12%", "₹ 99.9"
    const cleaned = s.replace(/,/g, "").replace(/[^0-9.-]/g, "");
    if (!cleaned || cleaned === "-" || cleaned === "." || cleaned === "-.") return 0;

    const n = Number(cleaned);
    return Number.isFinite(n) ? n : 0;
  }

  // booleans/objects/etc
  return 0;
};

const int0 = (v) => Math.trunc(num0(v));

// Derives base_quantity from available API response fields.
// Priority: direct field → item_pack_size/item_quantity → sum(itemBatchData)/item_quantity
const deriveBaseQty = (item) => {
  if (item?.base_quantity) return parseFloat(item.base_quantity);
  const packQty = parseFloat(item?.item_quantity) || 0;
  if (packQty > 0) {
    const packSize = parseFloat(item?.item_pack_size) || 0;
    if (packSize > 0) return Math.round(packSize / packQty);
    const totalBatchQty = (item?.itemBatchData ?? []).reduce(
      (sum, b) => sum + (parseInt(b?.item_batch_quantity) || 0),
      0
    );
    if (totalBatchQty > 0) return Math.round(totalBatchQty / packQty);
  }
  return 1;
};

  const searchRef = useRef(null);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");

  const [buttonLoading, setButtonLoading] = useState(false);
  const isDispatchingRef = useRef(false);
  const submitScheduledRef = useRef(false);

  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const initialData = {
    sl_no: 1,
    item_code: "",
    item_generic_name: "",
    item_name: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_to_be_delivered: 0,
    quantity: 0,
    item_free_quantity: 0,
    item_batches: [],
    item_discount_amount: 0.0,
    item_total_tax_percentage: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    instock: true,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst: 0,
    item_uom_id: "",
    item_manufacturer_id: "",
    pot_id: null,
    pos_id: null,
    base_quantity: 1,
    base_ref_id: null,
    base_ref_type: null,
    base_ref_line_id: null,
    base_ref_doc_number: null,
  };

  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    remarks: vendorDetails?.[0]?.remarks ?? "",
    // customer_invoice_number: vendorDetails?.[0]?.customer_invoice_number ?? null,
    is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
    ...(vendorDetails?.[0]?.srt_id
      ? { srt_id: vendorDetails?.[0]?.srt_id }
      : {}),
    srt_order_date: vendorDetails?.[0]?.srt_order_date && !isClone
      ? moment(vendorDetails?.[0]?.srt_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    srt_document_date: vendorDetails?.[0]?.srt_document_date && !isClone
      ? moment(vendorDetails?.[0]?.srt_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    srt_delivery_date: vendorDetails?.[0]?.srt_delivery_date && !isClone
      ? moment(vendorDetails?.[0]?.srt_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    srt_reference_inv_date: vendorDetails?.[0]?.srt_reference_inv_date
      ? moment(vendorDetails?.[0]?.srt_reference_inv_date).format("YYYY-MM-DD")
      : "",
    cmr_gstin: vendorDetails?.[0]?.cmr_gstin ?? "",
    pot_id: vendorDetails?.[0]?.pot_id ?? null,
    pos_id: vendorDetails?.[0]?.pos_id ?? null,
    srt_sub_total: isClone ? 0 : vendorDetails?.[0]?.srt_sub_total || "0.00",
    srt_total_discount: isClone
      ? 0
      : vendorDetails?.[0]?.srt_total_discount ?? 0,
    srt_total_gst: isClone ? 0 : vendorDetails?.[0]?.srt_total_gst || "0.00",
    srt_round_off_value: isClone
      ? 0
      : vendorDetails?.[0]?.srt_round_off_value || "0.00",
    srt_total_amount: isClone
      ? 0
      : vendorDetails?.[0]?.srt_total_amount || "0.00",
    cmr_tcs: "",
    cmr_tds: "",
    srt_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    srt_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage ?? 0,
    srt_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    srt_tcs_or_tds_amount: vendorDetails?.[0]?.tcs_or_tds_amount ?? 0,
    srt_order_status: vendorDetails?.[0]?.srt_order_status ?? "",
    srt_is_invoice_dis_percentage:
      vendorDetails?.[0]?.srt_is_invoice_dis_percentage ?? true,
    srt_invoice_discount: vendorDetails?.[0]?.srt_invoice_discount ?? 0,
    srt_invoice_discount_percentage:
      vendorDetails?.[0]?.srt_invoice_discount_percentage ?? 0,
    srt_pay_to_address: payto, //new
    srt_ship_to_address: shipto, //new
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.srt_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.srt_invoice_discount_percentage
      : vendorDetails?.[0]?.srt_invoice_discount,
    customer_invoice_number:vendorDetails?.[0]?.customer_invoice_number ?? null,
    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_uom: item?.item_uom ?? "--",
        item_to_be_delivered: item?.item_to_be_delivered ?? 0,
        quantity:
          type === "sales"
            ? 0
            : item?.item_to_be_delivered ?? item?.item_quantity,
        item_free_quantity: item?.item_batches?.reduce(
          (sum, batch) =>
            sum + (parseInt(batch.item_batch_free_quantity, 10) || 0),
          0
        ),
        item_batches:
          type === "sales" || isClone
            ? []
            : item?.itemBatchData?.map((batch) => ({
                item_batch_number: batch?.item_batch_number ?? 0,
                item_batch_quantity: parseInt(batch?.item_batch_quantity) || 0,
                gst_type:vendorDetails?.[0]?.gst_type,
                item_batch_free_quantity:
                  parseInt(batch?.item_batch_free_quantity) || 0,
                item_batch_sales_rate:
                  parseFloat(batch?.item_batch_sales_rate) || 0,
                item_batch_total_base_sales_rate:
                  parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                item_batch_discount_percentage:
                  parseFloat(batch?.item_batch_discount_percentage) || 0,
                item_batch_discount_amount:
                  parseFloat(batch?.item_batch_discount_amount) || 0,
                item_batch_discounted_sales_rate:
                  parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                item_batch_tax_percentage:
                  parseFloat(batch?.item_batch_tax_percentage) || 0,
                item_batch_tax_amount:
                  parseFloat(batch?.item_batch_tax_amount) || 0,
                item_batch_final_sales_rate:
                  parseFloat(batch?.item_batch_final_sales_rate) || 0,
                item_batch_total_sales_rate:
                  parseFloat(batch?.item_batch_total_sales_rate) || 0,
                item_batch_unit_price:
                  parseFloat(batch?.item_batch_unit_price) || 0,
                item_exp_date: batch?.item_exp_date
                  ? moment(batch?.item_exp_date).format("YYYY-MM-DD")
                  : null, // Default to today
                item_id: batch?.item_id ?? 0,
                from_bin_location: batch?.from_bin_location ?? "",
                item_batch_cgst_percentage:(batch?.item_batch_cgst_percentage||0),
                  item_batch_sgst_percentage:(batch?.item_batch_sgst_percentage||0),
                  item_batch_igst_percentage:(batch?.item_batch_igst_percentage||0),
                  item_batch_cgst_amount:(batch?.item_batch_cgst_amount||0),
                  item_batch_sgst_amount:(batch?.item_batch_sgst_amount||0),
                  item_batch_igst_amount:(batch?.item_batch_igst_amount||0),
                  item_batch_ptr_amount:
                      parseFloat(batch?.item_batch_ptr_amount) || 0,
                  item_batch_pts:
                      parseFloat(batch?.item_batch_pts_amount) || 0,
                from_bin_id: batch?.from_bin_id ?? 0,
                item_batch_avail_quantity: parseInt(batch?.item_batch_quantity),
              })) ?? [],
        item_discount_amount: isClone ? 0 : item?.item_discount_amount,
        item_total_tax_percentage: isClone
          ? 0
          : item?.item_total_tax_percentage,
        item_tax_amount: isClone ? 0 : item?.item_tax_amount ?? 0,
        item_total_amount: isClone ? 0 : item?.item_total_amount,
        item_id: item?.item_id,
        sodtt_id: item?.sodtt_id,
        instock: true,
        item_gst: item?.item_gst,
        item_cgst: item?.item_cgst,
        item_sgst: item?.item_sgst,
        item_igst: item?.item_igst,
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              base_quantity: uom?.base_quantity ?? 1,
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
            }))
          : (item?.item_uom_id
              ? [
                  {
                    item_uom_id: item.item_uom_id,
                    label: item.item_uom,
                    value: item.item_uom,
                    base_quantity: deriveBaseQty(item),
                  },
                ]
              : []),
        item_uom_id: item?.item_uom_id ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
        soit_id: item?.soit_id ?? null,
        sott_id: item?.sott_id ?? null,
        sodtt_id: item?.sodtt_id ?? null,
        base_ref_id: item?.soit_id ?? item?.sodtt_id ?? item?.sott_id ?? null,
        base_ref_type: item?.ref_type ?? null,
        base_ref_line_id: item?.item_id ?? null,
        base_ref_doc_number: item?.ref_doc_number ?? null,
        base_quantity: deriveBaseQty(item),
      })),
      initialData,
    ],
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));

    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const salesData = parsed.find((obj) => obj?.sales_return_create);
      if (salesData?.sales_return_create) {
        const cols = [...salesData.sales_return_create];
        if (!cols.some((c) => c.value === "item_pack_size")) {
          const qtyIdx = cols.findIndex((c) => c.value === "quantity");
          const insertAt = qtyIdx !== -1 ? qtyIdx + 1 : cols.length;
          cols.splice(insertAt, 0, {
            label: "Unit Qty",
            value: "item_pack_size",
            minWidth: 80,
            alignment: "right",
          });
        }
        setHeading(cols);
      }
    }
  }, []);

  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils")
        return;
    }
  };
  const onErrorStoreDetails = () => {};
  const handleSubmit = (values, actions) => {
    // Block duplicate submissions while a request is already in flight.
    if (isDispatchingRef.current) return;
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if(!values?.srt_pay_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    if(!values?.srt_ship_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    if (
      page === "edit" 
      // &&
      // values?.submittedButton !== "draft" &&
      // values?.srt_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);
      const data={
      orderData: {
        is_draft_order: values.submittedButton === "draft",
        store_id: storeId,
        ...(values?.srt_id ? { srt_id: values?.srt_id } : {}),

        // ✅ numeric-safe
        srt_total_gst: num0(values?.srt_total_gst),
        srt_total_discount: num0(values?.srt_total_discount),
        srt_total_amount: num0(values?.srt_total_amount),
        srt_sub_total: num0(values?.srt_sub_total),
        srt_round_off_value: num0(values?.srt_round_off_value),
        customer_invoice_number:values?.customer_invoice_number?? null,
        srt_payment_status: "paid",
        srt_transaction_id: "",
        srt_billing_address: "",

        cmr_code: values?.cmr_code?.label,
        cmr_id: values?.cmr_id,
        cmr_name: values?.cmr_name?.label,
        remarks: values?.remarks,
        srt_document_date: values?.srt_document_date,
        srt_delivery_date: values?.srt_delivery_date,
        srt_reference_inv_date: values?.srt_reference_inv_date|| null,
        cmr_gstin: values?.cmr_gstin || null,
        pot_id: values?.pot_id ?? null,
        pos_id: values?.pos_id ?? null,
        srt_tcs_or_tds_percentage_id: values?.srt_tcs_or_tds_percentage_id ?? "",
        srt_tcs_or_tds_percentage: num0(values?.srt_tcs_or_tds_percentage),
        srt_tds_tcs_type: values?.srt_tds_tcs_type ?? "",
        srt_tcs_or_tds_amount: num0(values?.srt_tcs_or_tds_amount),

        srt_is_invoice_dis_percentage: values?.srt_is_invoice_dis_percentage,

        // ✅ numeric-safe
        srt_invoice_discount: num0(values?.srt_invoice_discount),
        srt_invoice_discount_percentage: num0(values?.srt_invoice_discount_percentage),

        srt_pay_to_address: values?.srt_pay_to_address || null,
        srt_ship_to_address: values?.srt_ship_to_address || null,
        gst_type:values?.is_inter_state===false?"Intra":"Inter"
      },

      itemData: values.data?.slice(0, -1).map((item) => ({
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,
        ...(values?.srt_id ? { srt_id: values?.srt_id } : {}),
        // ✅ ints
        item_quantity: int0(item?.quantity),
        item_free_quantity: int0(item?.item_free_quantity),

        item_batch_number: item?.item_batch_number,
        item_schedule: item?.item_schedule,

        // ✅ numeric-safe
        item_discount_amount: num0(item?.item_discount_amount),
        item_total_tax_percentage: num0(item?.item_total_tax_percentage),
        item_tax_amount: num0(item?.item_tax_amount),
        item_total_amount: num0(item?.item_total_amount),

        item_id: item?.item_id,
        ...(item?.sott_id ? { sott_id: item?.sott_id } : { sott_id: null }),
        ...(item?.sodtt_id ? { sodtt_id: item?.sodtt_id } : { sodtt_id: null }),
        base_ref_id: item?.base_ref_id ?? null,
        base_ref_type: item?.base_ref_type ?? null,
        base_ref_line_id: item?.base_ref_line_id ?? null,
        base_ref_doc_number: item?.base_ref_doc_number ?? null,

        // ✅ numeric-safe
        item_gst: num0(item?.item_gst),
        item_sgst: values?.is_inter_state===false?num0(item?.item_sgst):0,
        item_cgst: values?.is_inter_state===false?num0(item?.item_cgst):0,
        item_igst: values?.is_inter_state===true?num0(item?.item_igst):0,
        item_uom_id: item?.item_uom_id ?? "",
        item_uom: item?.item_uom ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        item_manufacturer_name: item?.item_manufacturer_name ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
       })),

      itemBatchData: values.data
        ?.slice(0, -1)
        .map((item) => item.item_batches)
        .flat()
        .map((batch) => ({
          item_batch_number: batch?.item_batch_number,
          ...(values?.srt_id ? { srt_id: values?.srt_id } : {}),
          // ✅ ints
          item_batch_quantity: int0(batch?.item_batch_quantity),
          item_batch_free_quantity: int0(batch?.item_batch_free_quantity),

          // ✅ numeric-safe
          item_batch_sales_rate: num0(batch?.item_batch_sales_rate),
          item_batch_total_base_sales_rate: num0(batch?.item_batch_total_base_sales_rate),
          item_batch_discount_percentage: num0(batch?.item_batch_discount_percentage),
          item_batch_discount_amount: num0(batch?.item_batch_discount_amount),
          item_batch_discounted_sales_rate: num0(batch?.item_batch_discounted_sales_rate),
          item_batch_tax_percentage: num0(batch?.item_batch_tax_percentage),
          item_batch_tax_amount: num0(batch?.item_batch_tax_amount),
          item_batch_final_sales_rate: num0(batch?.item_batch_final_sales_rate),
          item_batch_total_sales_rate: num0(batch?.item_batch_total_sales_rate),
          item_batch_unit_price: num0(batch?.item_batch_unit_price),

          item_exp_date: batch?.item_exp_date,
          item_id: batch?.item_id,
          from_bin_location: batch?.from_bin_location,
          from_bin_id: batch?.from_bin_id,
          item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
            item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
            item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
            item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
            item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
            item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
          item_batch_ptr_amount:
            parseFloat(batch?.item_batch_ptr_amount) || 0,
          item_batch_pts_amount:
            parseFloat(batch?.item_batch_pts) || 0,
        })),
    }
      dispatch(
        salesReturnEditAction(
          data,
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if (values?.data?.length > 0) {
          isDispatchingRef.current = true;
          setButtonLoading(true);

          dispatch(
  salesReturnReceiptCreateAction(
    {
      orderData: {
        is_draft_order: values.submittedButton === "draft",
        store_id: storeId,
        ...(values?.srt_id ? { srt_id: values?.srt_id } : {}),

        // ✅ numeric-safe
        srt_total_gst: num0(values?.srt_total_gst),
        srt_total_discount: num0(values?.srt_total_discount),
        srt_total_amount: num0(values?.srt_total_amount),
        srt_sub_total: num0(values?.srt_sub_total),
        srt_round_off_value: num0(values?.srt_round_off_value),

        srt_payment_status: "paid",
        srt_transaction_id: "",
        srt_billing_address: "",

        cmr_code: values?.cmr_code?.label,
        cmr_id: values?.cmr_id,
        cmr_name: values?.cmr_name?.label,
        remarks: values?.remarks,
        srt_document_date: values?.srt_document_date,
        srt_delivery_date: values?.srt_delivery_date,
        srt_reference_inv_date: values?.srt_reference_inv_date|| null,
        cmr_gstin: values?.cmr_gstin || null,
        pot_id: values?.pot_id ?? null,
        pos_id: values?.pos_id ?? null,
        customer_invoice_number:values?.customer_invoice_number??null,
        srt_tcs_or_tds_percentage_id: values?.srt_tcs_or_tds_percentage_id ?? "",
        srt_tcs_or_tds_percentage: num0(values?.srt_tcs_or_tds_percentage),
        srt_tds_tcs_type: values?.srt_tds_tcs_type ?? "",
        srt_tcs_or_tds_amount: num0(values?.srt_tcs_or_tds_amount),

        srt_is_invoice_dis_percentage: values?.srt_is_invoice_dis_percentage,

        // ✅ numeric-safe
        srt_invoice_discount: num0(values?.srt_invoice_discount),
        srt_invoice_discount_percentage: num0(values?.srt_invoice_discount_percentage),

        srt_pay_to_address: values?.srt_pay_to_address || null,
        srt_ship_to_address: values?.srt_ship_to_address || null,
        gst_type:values?.is_inter_state===false?"Intra":"Inter"
      },

      itemData: values.data?.slice(0, -1).map((item) => ({
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,

        // ✅ ints
        item_quantity: int0(item?.quantity),
        item_free_quantity: int0(item?.item_free_quantity),

        item_batch_number: item?.item_batch_number,
        item_schedule: item?.item_schedule,

        // ✅ numeric-safe
        item_discount_amount: num0(item?.item_discount_amount),
        item_total_tax_percentage: num0(item?.item_total_tax_percentage),
        item_tax_amount: num0(item?.item_tax_amount),
        item_total_amount: num0(item?.item_total_amount),

        item_id: item?.item_id,
        ...(item?.sott_id && type === "sales" ? { sott_id: item?.sott_id } : { sott_id: null }),
        ...(item?.sodtt_id && type === "delivery" ? { sodtt_id: item?.sodtt_id } : { sodtt_id: null }),
        base_ref_id: item?.base_ref_id ?? null,
        base_ref_type: item?.base_ref_type ?? null,
        base_ref_line_id: item?.base_ref_line_id ?? null,
        base_ref_doc_number: item?.base_ref_doc_number ?? null,

        // ✅ numeric-safe
        item_gst: num0(item?.item_gst),
        item_sgst: values?.is_inter_state===false?num0(item?.item_sgst):0,
        item_cgst: values?.is_inter_state===false?num0(item?.item_cgst):0,
        item_igst: values?.is_inter_state===true?num0(item?.item_igst):0,
        item_uom_id: item?.item_uom_id ?? "",
        item_uom: item?.item_uom ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        item_manufacturer_name: item?.item_manufacturer_name ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
      })),

      itemBatchData: values.data
        ?.slice(0, -1)
        .map((item) => item.item_batches)
        .flat()
        .map((batch) => ({
          item_batch_number: batch?.item_batch_number,

          // ✅ ints
          item_batch_quantity: int0(batch?.item_batch_quantity),
          item_batch_free_quantity: int0(batch?.item_batch_free_quantity),

          // ✅ numeric-safe
          item_batch_sales_rate: num0(batch?.item_batch_sales_rate),
          item_batch_total_base_sales_rate: num0(batch?.item_batch_total_base_sales_rate),
          item_batch_discount_percentage: num0(batch?.item_batch_discount_percentage),
          item_batch_discount_amount: num0(batch?.item_batch_discount_amount),
          item_batch_discounted_sales_rate: num0(batch?.item_batch_discounted_sales_rate),
          item_batch_tax_percentage: num0(batch?.item_batch_tax_percentage),
          item_batch_tax_amount: num0(batch?.item_batch_tax_amount),
          item_batch_final_sales_rate: num0(batch?.item_batch_final_sales_rate),
          item_batch_total_sales_rate: num0(batch?.item_batch_total_sales_rate),
          item_batch_unit_price: num0(batch?.item_batch_unit_price),
          item_batch_ptr_amount:
              parseFloat(batch?.item_batch_ptr_amount) || 0,
          item_batch_pts_amount:
            parseFloat(batch?.item_batch_pts) || 0,
          item_exp_date: batch?.item_exp_date,
          item_id: batch?.item_id,
          from_bin_location: batch?.from_bin_location,
          from_bin_id: batch?.from_bin_id,
          item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
            item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
            item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
            item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
            item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
            item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
        })),
    },
    onSuccessOrder,
    onErrorOrder
  )
);

        }
      }
    }
  };

  const autoDraft = (values, actions) => {
    if (isDispatchingRef.current) return;
    // used for auto draft on clicking add new address
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.srt_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);

      dispatch(
        salesReturnEditAction(
          {
            is_draft_order: true,
            only_remarks: true,
            srt_id: values?.srt_id,
            remarks: values?.remarks,
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        const hasItems = (values?.data?.length ?? 0) > 1;
        if (hasItems) {
          isDispatchingRef.current = true;
          setButtonLoading(true);

          dispatch(
            salesReturnReceiptCreateAction(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: storeId,
                  ...(values?.srt_id ? { srt_id: values?.srt_id } : {}),
                  srt_total_gst: values?.srt_total_gst,
                  srt_total_discount: values?.srt_total_discount,
                  srt_payment_status: "paid",
                  srt_transaction_id: "",
                  srt_billing_address: "",
                  srt_total_amount: values?.srt_total_amount,
                  srt_sub_total: values?.srt_sub_total,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  srt_document_date: values?.srt_document_date,
                  srt_delivery_date: values?.srt_delivery_date,
                  srt_reference_inv_date: values?.srt_reference_inv_date|| null,
                  cmr_gstin: values?.cmr_gstin || null,
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? null,
                  srt_round_off_value: values?.srt_round_off_value,
                  srt_tcs_or_tds_percentage_id:
                    values?.srt_tcs_or_tds_percentage_id ?? "",
                  srt_tcs_or_tds_percentage:
                    values?.srt_tcs_or_tds_percentage ?? 0,
                  srt_tds_tcs_type: values?.srt_tds_tcs_type ?? "",
                  srt_tcs_or_tds_amount: values?.srt_tcs_or_tds_amount ?? 0,
                  customer_invoice_number: values?.customer_invoice_number,
                  srt_is_invoice_dis_percentage:
                    values?.srt_is_invoice_dis_percentage,
                  srt_invoice_discount: values?.srt_invoice_discount,
                  srt_invoice_discount_percentage:
                    values?.srt_invoice_discount_percentage,
                  srt_pay_to_address: values?.srt_pay_to_address || null, //new
                  srt_ship_to_address: values?.srt_ship_to_address || null, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter"
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_quantity: parseInt(item?.quantity) || 0,
                  item_free_quantity: parseInt(item?.item_free_quantity) || 0,
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_discount_amount: parseFloat(item?.item_discount_amount),
                  item_total_tax_percentage: item?.item_total_tax_percentage,
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_total_amount: item?.item_total_amount,
                  item_id: item?.item_id,
                  ...(item?.sott_id && type === "sales"
                    ? { sott_id: item?.sott_id }
                    : { sott_id: null }),
                  ...(item?.sodtt_id && type === "delivery"
                    ? { sodtt_id: item?.sodtt_id }
                    : { sodtt_id: null }),
                  base_ref_id: item?.base_ref_id ?? null,
                  base_ref_type: item?.base_ref_type ?? null,
                  base_ref_line_id: item?.base_ref_line_id ?? null,
                  base_ref_doc_number: item?.base_ref_doc_number ?? null,
                  item_gst: parseFloat(item?.item_gst),
                  item_sgst: values?.is_inter_state===false?parseFloat(item?.item_sgst||0):0,
                  item_cgst: values?.is_inter_state===false?parseFloat(item?.item_cgst||0):0,
                  item_igst: values?.is_inter_state===true?parseFloat(item?.item_igst||0):0,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? null,

                })),

                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_batch_quantity: parseInt(batch?.item_batch_quantity),
                    item_batch_free_quantity: parseInt(
                      batch?.item_batch_free_quantity
                    ),
                    item_batch_sales_rate: parseFloat(
                      batch?.item_batch_sales_rate
                    ),
                    item_batch_total_base_sales_rate:
                      parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                    item_batch_discount_percentage:
                      batch?.item_batch_discount_percentage,
                    item_batch_discount_amount: parseFloat(
                      batch?.item_batch_discount_amount
                    ),
                    item_batch_discounted_sales_rate:
                      parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                    item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: parseFloat(
                      batch?.item_batch_tax_amount
                    ),
                    item_batch_final_sales_rate: parseFloat(
                      batch?.item_batch_final_sales_rate
                    ),
                    item_batch_total_sales_rate: parseFloat(
                      batch?.item_batch_total_sales_rate
                    ),
                    item_batch_unit_price: parseFloat(
                      batch?.item_batch_unit_price
                    ),
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                    item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
                    item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
                    item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
                    item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
                    item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
                    item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
                    item_batch_ptr_amount:
                      parseFloat(batch?.item_batch_ptr_amount) || 0,
                    item_batch_pts_amount:
                      parseFloat(batch?.item_batch_pts) || 0,
                  })),
              },
              (data) => {
                successToast(data?.message);
                // setLoading(true);
                setTimeout(() => {
                  // setLoading(false);
                }, 50);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-sales-return/${data?.data?.orderData?.srt_id}`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                errorToast(data?.data?.message);
              }
            )
          );
        } else {
          navigate(
            `/edit-customer-admin/${values?.cmr_id}?backto=/add-sales-return/%255B%255D/delivery?new`,
            {
              state: { tab: "Address" },
            }
          );
        }
      }
    }
  };
  const onSuccessOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);
    if (formValues?.submittedButton === "print") {
      handlea4Print(data?.data?.orderData?.srt_id, "sales_return", dispatch);
    }
    navigate("/sales-return");
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_id: "",
      remarks: "",
      srt_total_discount: 0,
      srt_order_date: null,
      srt_document_date: null,
      srt_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);
    errorToast(data?.data?.message);
  };

  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        if (submitScheduledRef.current || isDispatchingRef.current) {
          actions.setSubmitting(false);
          return;
        }
        submitScheduledRef.current = true;
        setButtonLoading(true);
        setTimeout(() => {
          submitScheduledRef.current = false;
          handleSubmit(values, actions); // arms isDispatchingRef on dispatch
          if (!isDispatchingRef.current) {
            setButtonLoading(false);
          }
          actions.setSubmitting(false); // Notify Formik that submission is done
        }, 500);
      }}
    >
      {({ values, setFieldValue, errors }) => {
        setFormValues(values);

        return (
          <Form className="h-full">
            <div
              style={{
                height: `calc(100% - 8rem)`,
              }}
              className="mx-5 flex flex-col h-full "
            >
              <SalesRCNBatchesPanel
                searchRef={searchRef}
                open={addbatch}
                setOpen={setAddbatch}
                disabled={disabled}
                setItemId={setItemId}
                itemId={itemId}
                itemValues={values}
                prefix="srt"
              />
              <SalesPurchaseNavbar
                autoDraft={autoDraft}
                clickedplus={clickedplus}
                isClone={isClone}
                pageType={pageType}
                page={page}
                isCusInvNumRequired={true}
                section="sales"
                name="srt"
                disabled={disabled}
                searchRef={searchRef}
                storeDetails={storeDetails}
                transfer={transfer}
                standAlone={standAlone}
              />
              <SalesItemsSection
                isClone={isClone}
                refetchStockOnClone={true}
                clickedplus={clickedplus}
                heading={heading}
                standAlone={standAlone}
                qtyDis={true}
                type={type}
                disabled={values.is_inter_state===null || disabled}
                addBatchFn={(id) => {
                  setAddbatch(true);
                  setItemId(id);
                }}
                searchRef={searchRef}
                initialData={initialData}
                isNotViewOnly={isNotViewOnly}
                prefixName="srt"
                itemValues={values}
              />
            </div>
            <SalesPurchaseFooter
              modules="sales"
              EditFn={() => {
                navigate(`/edit-sales-return/${values?.srt_id}`);
              }}
              transaction="Sales Return"
              transaction_type="sales_return"
              buttonLoading={buttonLoading}
              name="srt_total_discount"
              page={page}
              disabled={disabled}
              prefixName="srt"
              tcsTdsAmount={tcsTdsAmount}
              setTcsTdsAmount={setTcsTdsAmount}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEditViewSalesRet;
